<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yqbC7F/tc-custom/9781609253936.jpg?1726617332214" alt="This image is the cover for the book Luminaries, Seminars in Psychological Astrology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Luminaries, Seminars in Psychological Astrology
      </h1>
      <p class="bookDescription body article font2">
        <b>From the founders of the Centre for Psychological Astrology, the third seminar in their series for practitioners discusses sun and moon signs.</b><br/><br/>Liz Greene and Howard Sasportas, psychologists, astrologers and founders of the Centre for Psychological Astrology in London continue their series of seminars with <i>The Luminaries. </i>In this book, they discuss the mythology and psychology of the Moon, showing its relevance as a significator of relationships. In addition, the authors explore in depth the correspondence between the Sun and the development of consciousness. <i>The Luminaries </i>also includes a chapter on the lunation cycle.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Liz Greene, Howard Sasportas
      </h2>
      
      <p class="authorDescription body article">Liz Greene is the cofounder of the Centre for Psychological Astrology in London and a contributor to the most respected astrology site on the web: www.astro.com, as well as a regular contributor to Astrodientst.com. She is the author of Astrology for Lovers and Relating: An Astrological Guide to Living with Others on a Small Planet. Greene currently resides in Zurich, Switzerland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Red Wheel/Weiser, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ff8ba96